export default __webpack_public_path__ + "static/media/fiona.8318e962.png";